import { FC, HTMLAttributes, ReactNode } from "react";
import { cn } from "src/lib/utils";

interface Props extends HTMLAttributes<HTMLDivElement> {
	title: string;
	description?: string;
	icon?: ReactNode;
	action?: ReactNode;
}

const EmptyState: FC<Props> = ({
	title,
	description,
	icon,
	action,
	className,
	...restProps
}) => {
	return (
		<div
			className={cn(
				"bg-white border border-border rounded-xl py-12 shadow-xs",
				className
			)}
			{...restProps}
		>
			<div className="flex flex-col items-center justify-center">
				{icon && (
					<div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
						{icon}
					</div>
				)}

				<h2
					className={cn(
						"font-heading text-lg font-medium text-foreground",
						description || action ? "mb-2" : ""
					)}
				>
					{title}
				</h2>

				{description && (
					<p className="max-w-[650px] text-center text-sm text-muted-foreground">
						{description}
					</p>
				)}

				{action && <div className="mt-4">{action}</div>}
			</div>
		</div>
	);
};

export default EmptyState;
